import { toDisplayString as _toDisplayString, createVNode as _createVNode, createTextVNode as _createTextVNode, resolveComponent as _resolveComponent, withCtx as _withCtx, openBlock as _openBlock, createBlock as _createBlock, createCommentVNode as _createCommentVNode, withScopeId as _withScopeId, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"
const _withId = /*#__PURE__*/_withScopeId("data-v-a2fe3f3a")

_pushScopeId("data-v-a2fe3f3a")
const _hoisted_1 = { class: "bg-white py-6 px-6 rounded-lg mb-4" }
const _hoisted_2 = { class: "flex flex-col w-full mb-1" }
const _hoisted_3 = { class: "mb-4 px-3" }
const _hoisted_4 = { class: "font-bold text-lg mb-4" }
const _hoisted_5 = { class: "mb-2" }
const _hoisted_6 = { class: "color-blue-grey" }
const _hoisted_7 = { class: "mb-4 px-3" }
const _hoisted_8 = {
  key: 0,
  class: "action-button py-5"
}
const _hoisted_9 = /*#__PURE__*/_createTextVNode("Kembali")
_popScopeId()

export const render = /*#__PURE__*/_withId((_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) => {
  const _component_Column = _resolveComponent("Column")
  const _component_InputSwitch = _resolveComponent("InputSwitch")
  const _component_DataTable = _resolveComponent("DataTable")
  const _component_Button = _resolveComponent("Button")

  return (_openBlock(), _createBlock("section", null, [
    _createVNode("div", _hoisted_1, [
      _createVNode("div", _hoisted_2, [
        _createVNode("div", _hoisted_3, [
          _createVNode("p", _hoisted_4, _toDisplayString(_ctx.$route.query.title), 1),
          _createVNode("div", _hoisted_5, [
            _createVNode("p", _hoisted_6, _toDisplayString(_ctx.$route.query.keterangan), 1)
          ])
        ]),
        _createVNode("div", _hoisted_7, [
          _createVNode(_component_DataTable, {
            value: _ctx.listGroup,
            rows: 100,
            class: "table-og",
            responsiveLayout: "scroll"
          }, {
            default: _withId(() => [
              _createVNode(_component_Column, { header: "Group User" }, {
                body: _withId((slotProps) => [
                  _createTextVNode(_toDisplayString(slotProps.data.label), 1)
                ]),
                _: 1
              }),
              _createVNode(_component_Column, { header: "Aktif" }, {
                body: _withId((slotProps) => [
                  _createVNode(_component_InputSwitch, {
                    onChange: ($event: any) => (_ctx.changeIsActive(slotProps.data)),
                    class: "switch-og",
                    modelValue: slotProps.data.IsActive,
                    "onUpdate:modelValue": ($event: any) => (slotProps.data.IsActive = $event)
                  }, null, 8, ["onChange", "modelValue", "onUpdate:modelValue"])
                ]),
                _: 1
              })
            ]),
            _: 1
          }, 8, ["value"])
        ]),
        false
          ? (_openBlock(), _createBlock("div", _hoisted_8, [
              _createVNode(_component_Button, {
                label: "Simpan",
                class: "font-semibold p-button-sm btn-primary px-10 mr-2",
                onClick: _cache[1] || (_cache[1] = ($event: any) => (_ctx.submitData()))
              }),
              _createVNode(_component_Button, {
                class: "btn-secondary text-black p-button-sm px-10 py-1",
                onClick: _cache[2] || (_cache[2] = ($event: any) => (_ctx.redirectBack()))
              }, {
                default: _withId(() => [
                  _hoisted_9
                ]),
                _: 1
              })
            ]))
          : _createCommentVNode("", true)
      ])
    ])
  ]))
})